import Head from 'next/head';
import { publicImageUrl } from '../../../lib/publicImageUrl';

export default function MetaHead({ currentDomain }: { currentDomain: string }) {
    const baseUrl = `https://${currentDomain}/99daysofdesign`;
    const ogImage = publicImageUrl('99daysofdesign/og.jpg');
    return (
        <Head>
            <title>99designs by Vistaprint presents - 99 Days of Design</title>
            {currentDomain === '99designs.com' ? (
                <link rel="canonical" href="https://99designs.com/99daysofdesign" />
            ) : (
                <meta name="robots" content="noindex" />
            )}
            <meta name="title" content="99designs by Vistaprint presents - 99 Days of Design" />
            <meta
                name="description"
                content="A program to fuel the success of 99 small businesses around the world through the power of great design. Follow these inspiring design revivals as they happen."
            />
            <meta property="og:type" content="website" />
            <meta property="og:url" content={`${baseUrl}`} />
            <meta
                property="og:title"
                content="99designs by Vistaprint presents - 99 Days of Design"
            />
            <meta
                property="og:description"
                content="A program to fuel the success of 99 small businesses around the world through the power of great design. Follow these inspiring design revivals as they happen."
            />
            <meta property="og:image" content={`${ogImage}`} />
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content={`${baseUrl}`} />
            <meta
                property="twitter:title"
                content="99designs by Vistaprint presents - 99 Days of Design"
            />
            <meta
                property="twitter:description"
                content="A program to fuel the success of 99 small businesses around the world through the power of great design. Follow these inspiring design revivals as they happen."
            />
            <meta property="twitter:image" content={`${ogImage}`} />
            <script src="/accounts/accounts.js" defer />
        </Head>
    );
}
